import Vue from 'vue'
import 'modules/image/image.vue'
import on from 'dom-event'
import Fragment from 'vue-fragment'
import state from 'lib/appState'
import { getHeight } from 'lib/util'
import { scrollToContent, scrollToByLocalStorage } from 'lib/scrolls'
import 'modules/header-search-icon/header-search-icon.vue'
import select from 'dom-select'

Vue.use(Fragment.Plugin)

const BREAKPOINT_MENU = 1000
const ANCHOR_LINK_SELECTOR = '.js-anchor-link'

Vue.component('main-header', {
  data() {
    return {
      state,
      isMobile: window.innerWidth <= BREAKPOINT_MENU,
      activeMenuId: null,
      activeAccordion: null,
      menuOpen: false,
      isScrolled: false,
      submenuHeight: 'auto',
    }
  },
  beforeDestroy() {
    on.off(window, 'scroll', this.onScrollProgress)
    on.off(window, 'resize', this.handleResize)
  },
  mounted() {
    on(window, 'scroll', this.onScrollProgress)
    on(window, 'resize', this.handleResize)
    on(window, 'load', () => {
      setTimeout(() => {
        scrollToByLocalStorage()
      }, 100)
      scrollToContent(ANCHOR_LINK_SELECTOR, false)
    })
  },
  computed: {
    isMenuOpen() {
      if (this.isMobile) return this.menuOpen
      return this.activeMenuId
    },
    realCartItemsCount() {
      return this.state.cart.items.reduce((count, item) => {
        if (item.properties && item.properties['_hide']) {
          return count
        }
        return count + item.quantity
      }, 0)
    },
  },
  watch: {
    isScrolled() {
      this.state.headerScrolled = this.isScrolled
    },
    menuOpen() {
      if (this.isMobile) {
        if (this.$refs.menuBlocksWrapper) {
          const mainHeaderHeight = this.$refs.header ? getHeight(this.$refs.header) : ''
          this.$refs.menuBlocksWrapper.style.top = mainHeaderHeight
        }
      } else {
        this.$refs.menuBlocksWrapper.style.top = ''
      }
    },
  },
  methods: {
    onScrollProgress() {
      this.isScrolled = window.scrollY > 20
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      if (this.isMobile) {
        const buttonMobile = select('.js-button-mobile', this.el)
        setTimeout(() => {
          const mobileMenu = select('.js-mobile-menu')
          if (mobileMenu) {
            const allFocusElement = select.all('a, input, button', mobileMenu)
            const firstFocusElement = select('a, input, button', mobileMenu)
            let lastFocusElement
            if (!this.menuOpen && allFocusElement) {
              allFocusElement.map((el) => {
                el.setAttribute('tabindex', '-1')
              })
            }
            if (this.menuOpen && allFocusElement) {
              allFocusElement.map((el) => {
                el.removeAttribute('tabindex')
              })
              lastFocusElement = allFocusElement[allFocusElement.length - 1]
              allFocusElement.map((el, index) => {
                if (index === 0) {
                  firstFocusElement.focus()
                }
                on(el, 'keydown', (e) => {
                  if (e.keyCode === 27) {
                    this.menuOpen = false
                    buttonMobile.focus()
                  }
                  if (
                    (index === allFocusElement.length - 1 && e.keyCode === 9 && !e.shiftKey) ||
                    (index === 0 && e.shiftKey && e.keyCode === 9)
                  ) {
                    e.preventDefault()
                    buttonMobile.focus()
                  }
                })
                on(buttonMobile, 'keydown', (e) => {
                  e.preventDefault()
                  if (e.keyCode === 9 && e.shiftKey) {
                    lastFocusElement.focus()
                  } else if (e.keyCode === 9 && !e.shiftKey) {
                    firstFocusElement.focus()
                  }
                })
              })
            }
          }
        }, 500)
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth <= BREAKPOINT_MENU
    },
    setActiveMenu(event, menuId = null) {
      const buttonTarget = event.currentTarget
      const parentTarget = buttonTarget.parentNode
      const subMenuTarget = parentTarget.lastChild

      if (parentTarget && subMenuTarget) {
        this.submenuHeight = this.isMobile ? 'auto' : getHeight(subMenuTarget)
      }

      if ((event.keyCode === 27 || event.keyCode === 13 || !event.keyCode) && this.activeMenuId === menuId) {
        this.activeMenuId = null
        return
      }

      if (this.isMobile) return null
      if (!event.keyCode || event.keyCode === 13) {
        this.activeMenuId = menuId
        const subItemActivated = select(`[data-id="${menuId}"]`)
        if (this.activeMenuId && subItemActivated) {
          const focusElements = select.all('a', subItemActivated)
          if (focusElements) {
            const shopAllEl = select('.js-shop-all', subItemActivated)
            let lastfocusElement
            if (shopAllEl && window.innerWidth > 1000) {
              lastfocusElement = focusElements[focusElements.length - 2]
            } else {
              lastfocusElement = focusElements[focusElements.length - 1]
            }
            on(lastfocusElement, 'keydown', (e) => {
              if (e.keyCode === 9 && !e.shiftKey) {
                this.activeMenuId = null
              }
            })
            focusElements.map((el) => {
              on(el, 'keydown', (e) => {
                if (e.keyCode === 27) {
                  this.activeMenuId = null
                  buttonTarget.focus()
                }
              })
            })
          }
        }
      }
    },
    setActiveAccordion(menuId) {
      if (this.activeAccordion === menuId) {
        this.activeAccordion = null
        return
      }
      this.activeAccordion = menuId
    },
    toggleMiniCart() {
      if (this.state.isMiniCartOpen && this.state.modalToggleEl) {
        this.state.modalToggleEl.focus()
      } else {
        this.state.modalToggleEl = document.activeElement
      }
      this.state.isMiniCartOpen = !this.state.isMiniCartOpen
    },
  },
})
